import IMAGES from 'components/images';

export const IMAGE_OPTION_MAP: Record<string, string> = {
  BrikVener: IMAGES.WALL_MATERIALS.BRICK_VENEER,
  DblBrik: IMAGES.WALL_MATERIALS.DOUBLE_BRICK,
  MudBrik: IMAGES.WALL_MATERIALS.MUD_BRICK,
  ClrBndStl: IMAGES.WALL_MATERIALS.COLORBOND_STEEL,
  CorrIron: IMAGES.WALL_MATERIALS.CORRIGATED_IRON,
  AlmCld: IMAGES.WALL_MATERIALS.ALUMINIUM_CLAD,
  Tin: IMAGES.WALL_MATERIALS.TIN,
  CncrtBlk: IMAGES.WALL_MATERIALS.CONCRETE_BRICK,
  FibCemFib: IMAGES.WALL_MATERIALS.CEMENT_FIBRE,
  WoodTimbr: IMAGES.WALL_MATERIALS.TIMBER,
  RockStone: IMAGES.WALL_MATERIALS.STONE,
};
